module.exports = __webpack_public_path__ + "img/clock_img.df015ef2.png";